export function tryParseGuid(value: string): string | null {
  const trimmed = value.trim();

  const dFormat = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  const nFormat = /^[0-9a-f]{32}$/i;

  let candidate = trimmed;
  if (
    (candidate.startsWith('{') && candidate.endsWith('}')) ||
    (candidate.startsWith('(') && candidate.endsWith(')'))
  ) {
    candidate = candidate.substring(1, candidate.length - 1);
  }

  if (dFormat.test(candidate)) {
    return candidate.toLowerCase();
  }

  if (nFormat.test(candidate)) {
    const hex = candidate.toLowerCase();
    return `${hex.substring(0, 8)}-${hex.substring(8, 12)}-${hex.substring(12, 16)}-${hex.substring(16, 20)}-${hex.substring(20)}`;
  }

  return null;
}

const BASE64_ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

function decodeBase64ToBytes(base64: string): number[] {
  const bytes: number[] = [];
  let buffer = 0;
  let bitCount = 0;

  for (const character of base64) {
    if (character === '=') {
      break;
    }

    const value = BASE64_ALPHABET.indexOf(character);
    if (value < 0) {
      throw new Error(`Invalid base64 character "${character}".`);
    }

    buffer = (buffer << 6) | value;
    bitCount += 6;
    if (bitCount >= 8) {
      bitCount -= 8;
      bytes.push((buffer >> bitCount) & 0xff);
    }
  }

  return bytes;
}

function byteToHex(byte: number): string {
  return byte.toString(16).padStart(2, '0');
}

export function base64ToGuid(base64: string): string {
  const parsedGuid = tryParseGuid(base64);
  if (parsedGuid !== null) {
    return parsedGuid;
  }

  const normalized = base64.replace(/_/g, '/').replace(/-/g, '+') + '==';

  const bytes = decodeBase64ToBytes(normalized);
  if (bytes.length !== 16) {
    throw new Error(`Byte array for GUID must be exactly 16 bytes long. Was ${bytes.length}.`);
  }

  const part1 = byteToHex(bytes[3]!) + byteToHex(bytes[2]!) + byteToHex(bytes[1]!) + byteToHex(bytes[0]!);
  const part2 = byteToHex(bytes[5]!) + byteToHex(bytes[4]!);
  const part3 = byteToHex(bytes[7]!) + byteToHex(bytes[6]!);
  const part4 = byteToHex(bytes[8]!) + byteToHex(bytes[9]!);
  const part5 = bytes.slice(10).map(byteToHex).join('');

  return `${part1}-${part2}-${part3}-${part4}-${part5}`;
}

